import { ChangeDetectorRef, Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Clipboard } from '@angular/cdk/clipboard';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DisableWhileLoadingDirective } from 'app/modules/shared/button-loading.directive';
import { CustomAlertService } from 'app/modules/shared/services/alert.service';

@Component({
    selector: 'app-delete-confirmation',
    standalone: true,
    imports: [TranslocoModule, CommonModule, MatButtonModule, MatDialogModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
        DisableWhileLoadingDirective
    ],
    templateUrl: './delete-confirmation.component.html',
    styleUrl: './delete-confirmation.component.scss',
})
export class DeleteConfirmationComponent implements OnInit, OnDestroy {
    data = inject(MAT_DIALOG_DATA);
    private _dialogRef = inject(MatDialogRef<DeleteConfirmationComponent>);
    private _clipboard = inject(Clipboard);
    private _alertService = inject(CustomAlertService);
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    form: FormGroup
    agentform: FormGroup
    reasonForm: FormGroup
    lang: string = 'en';
    constructor(private _changeDetectorRef: ChangeDetectorRef,
        private _translocoService: TranslocoService,
        private _fb: FormBuilder) {

    }
    ngOnInit() {
        // Dialogs open after lang is already set; langChanges$ does not replay the active value.
        this.lang = this._translocoService.getActiveLang() || 'en';
        this._translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
            this.lang = res;
            this._changeDetectorRef.markForCheck();
        });
        this.form = this._fb.group({
            name: ['', [Validators.required]]
        });
        this.agentform = this._fb.group({
            name: ['', [Validators.required]]
        });
        if (this.data?.showReason) {
            this.reasonForm = this._fb.group({
                reason: [''],
            });
        }
    }

    /** Type-to-confirm gate used by agent and organization deletes. */
    requiresTypedNameConfirm(): boolean {
        const from = this.data?.from;
        return from === 'agent' || from === 'organization';
    }

    /** The name/label shown (and required to be re-typed for datasource/agent/organization) in the "Do you
     *  really want to delete <name>?" sentence — mirrors the template's own from-based lookup. */
    getConfirmName(): string {
        const from = this.data?.from;
        const value =
            from === 'datasource' || from === 'agent' || from === 'organization' || from === 'datasourceTables' || from === 'procedure'
                ? this.data?.name
                : this.data;
        return (value ?? '').toString();
    }

    copyName(value: string): void {
        const text = (value ?? '').toString().trim();
        if (!text) {
            return;
        }
        this._clipboard.copy(text);
        this._alertService.successMessage('Copied');
    }

    confirmChat(): void {
        const reason = (this.reasonForm?.get('reason')?.value ?? '').trim();
        this._dialogRef.close({ confirmed: true, reason });
    }
    match: boolean = false;
    checkMatch(value) {
        this.match = false;
        if (value.toLowerCase().trim() == this.data.name.toLowerCase().trim()) {
            this.match = true;
            this._changeDetectorRef.markForCheck()
        }
    }

    agentMatch: boolean = false;
    checkAgentMatch(value) {
        this.agentMatch = false;
        if (value.toLowerCase().trim() == this.data.name.toLowerCase().trim()) {
            this.agentMatch = true;
            this._changeDetectorRef.markForCheck()
        }
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
